import * as React from 'react';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';

import {
    Typography, List, ListItem, ListItemText,
} from '@material-ui/core';
import { TopActionBar } from '../../common/components';

import urls from '../../app/urls';
import { HtmlContent } from '../../youwell-common/components';
import RedirectIfNoLicense from '../../common/components/RedirectIfNoLicense';

const styles = theme => ({
    root: {

    },
    content: {
        padding: theme.spacing(4),
    },
    skillsHeader: {
        marginTop: theme.spacing(4),
        padding: `${theme.spacing(2)}px ${theme.spacing(3)}px`,
        background: theme.colors.grey2,
    },
    programDescription: {
        color: theme.colors.blue4,
    },
});

class Program extends React.Component {
    render() {
        const { classes, programData, translate } = this.props;

        if (!programData) {
            return null;
        }

        return (
            <div className={classes.root}>
                <RedirectIfNoLicense />
                <TopActionBar
                    title={programData.name}
                    backLink={{
                        to: `${urls.inside.home}`,
                        text: translate('program.backToOverview'),
                    }}
                />

                <div className={classes.content}>
                    <HtmlContent html={programData.description} className={classes.programDescription} />

                    <Typography variant="h6" className={classes.skillsHeader}>
                        {translate('program.skillsHeader', { n: programData.modules.length })}
                    </Typography>

                    <List>
                        {programData.modules && programData.modules.map(item => (
                            <ListItem button component={Link} to={`${urls.inside.program.skill}/${item.id}`} key={item.id}>
                                <ListItemText
                                    primary={item.name || `[${translate('no_name')}]`}
                                />
                            </ListItem>
                        ))}
                    </List>
                </div>
            </div>
        );
    }
}

Program.propTypes = {
    classes: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
    programData: PropTypes.object,
};

Program.defaultProps = {
    programData: null,
};

const mapStateToProps = state => ({
    translate: getTranslate(state.localize),
    programData: state.program.programDetails,
});

export default connect(mapStateToProps)(withStyles(styles)(Program));
